<template>
<w-settings-content-template side-title="스냅샷 판단 기준 목록">
  <el-row slot="content" :gutter="20">
    <el-col :span="6">
      <el-row class="pb-b10 title-bar mr-t12">
        <div class="title-h3">스냅샷 판단 기준 목록</div>
      </el-row>
      <!-- 0429 a-left 추가 -->
      <el-table :data="tableData" highlight-current-row row-class-name="c-pointer" @row-click="onClickimportanceLevelId" ref="importanceTable" class="mr-b20 a-left">
        <el-table-column label="스냅샷 판단 기준명" prop="importanceLevelName" :formatter="importanceFormatter"></el-table-column>
      </el-table>
    </el-col>
    <el-col :span="18">
      <!-- <el-row style="padding-bottom: 10px;">
        <h4>{{targetTitle}}</h4>
      </el-row> -->
      <el-row type="flex" :span="18" justify="space-between" style="margin-bottom: 10px;" class="title-bar">
        <div class="vertical-center-box">
          <div class="title-h3 mr-r15">{{targetTitle}}</div>
          <el-select v-model="targetManagetypeId" @change="onChangeManagetypeId">
            <el-option v-for="item in managetypeList" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId"></el-option>
          </el-select>
        </div>
        <div class="btn-group-right ">
          <el-button size="small" type="primary" :disabled="!changeFlag" @click="clickSaveButton">저장</el-button>
          <el-button size="small" @click="clickResetButton" :disabled="!changeFlag">취소</el-button>
          <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :column-default="columnDefault" @condition-change="onChangeTable" :total="total" remote ref="snapshotTable" :data="snapshotPeriodData" :columns="snapshotPeriodColumns" :pagination="true" :show-search-tool="showSearchTool" style="width:100%;"
        :show-custom-header="true">
        <template #period-select="scope">
          <w-snapshot-period-select :targetData="scope.row" @check-change-flag="checkChangeFlag"></w-snapshot-period-select>
        </template>
      </el-table-wrapper>
    </el-col>
  </el-row>
</w-settings-content-template>
</template>

<script>
import { isEmpty, cloneDeep, isEqual, differenceWith, filter } from 'lodash';
import { columnDefault } from '@/constants/table';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import RscSettingsAPI from '@/api/settings/common/rsc-settings';
import msgUtil from '@/utils/message';
import WSnapshotPeriodSelect from './components/SnapshotPeriodSelect';

export default {
  name: 'WSnapshotPeriodSettings',
  components: {
    WSettingsContentTemplate,
    WSnapshotPeriodSelect,
  },
  data() {
    return {
      total: null,
      columnDefault,
      changeFlag: false,
      showSearchTool: false,
      targetManagetypeId: '',
      targetImportanceLevel: '',
      targetTitle: '',
      snapshotPeriodDataOrigin: '',
      tableData: [],
      snapshotPeriodData: [],
      snapshotPeriodColumns: [
        {
          prop: 'snapshotTypeId',
          label: '스냅샷 항목 ID',
          searchable: true,
          sortable: true,
          remoteProp: 'srs.snapshot_type_id',
        },
        {
          prop: 'snapshotTypeName',
          label: '스냅샷 항목명',
          searchable: true,
          sortable: true,
          remoteProp: 'sm.snapshot_type_name',
        },
        {
          prop: 'snapshotInterval',
          label: '스냅샷 주기',
          scopedSlot: 'period-select',
          searchable: true,
          width: 200,
          sortable: true,
          remoteProp: 'srs.snapshot_interval',
        },
      ],
    };
  },
  computed: {
    managetypeList() {
      // APM은 스냅샷 제공X
      return filter(this.$store.getters.activeManagetypesToShow, (data) => data.managetypeId !== 'APM2X');
    },
  },
  watch: {
    /**
     * 관리 구분 바인딩 시 첫번째 관리 구분이 자동으로 선택되도록 한다.
     * @author Ju
     * @param  {[type]} to [description]
     */
    managetypeList: {
      immediate: true,
      handler(to) {
        if (!isEmpty(to)) {
          this.targetManagetypeId = this.managetypeList[0].managetypeId;
          // 스냅샷 판단 기준 목록 로드
          RscSettingsAPI.getObjImportanceLevelList().then((response) => {
            if (response.data.success) {
              this.tableData = response.data.data;
              this.targetImportanceLevel = this.tableData[0];
              this.loadData();
              this.$nextTick(() => {
                this.$refs.importanceTable.setCurrentRow(this.tableData[0]);
              });
            }
          });
        }
      },
    },
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.snapshotTable.getParameter();
      const params = {
        managetypeId: this.targetManagetypeId,
        importanceLevelId: this.targetImportanceLevel.importanceLevelId,
        ...tableParams,
      };
      RscSettingsAPI.getSnapshotPeriodList(params).then((res) => {
        if (res.data.success) {
          this.snapshotPeriodData = res.data.data;
          this.snapshotPeriodDataOrigin = cloneDeep(res.data.data);
          this.total = res.data.total;
          this.checkChangeFlag();
        }
      });
      this.targetTitle = `${this.targetImportanceLevel.importanceLevelName} 관리대상 스냅샷 주기 설정`;
    },
    clickSaveButton() {
      const params = differenceWith(this.snapshotPeriodData, this.snapshotPeriodDataOrigin, isEqual);
      const target = '스냅샷 주기';
      const action = msgUtil.action.SAVE;
      RscSettingsAPI.updateSnapshotPeriodList(params)
        .then((res) => {
          if (res.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    onChangeTable() {
      this.loadData();
    },
    clickResetButton() {
      this.snapshotPeriodData = cloneDeep(this.snapshotPeriodDataOrigin);
      this.checkChangeFlag();
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    onClickimportanceLevelId(row) {
      this.targetImportanceLevel = row;
      this.loadData();
    },
    onChangeManagetypeId(value) {
      this.targetManagetypeId = value;
      this.loadData();
    },
    importanceFormatter(row) {
      return `${row.importanceLevelName} 관리대상 스냅샷 주기`;
    },
    checkChangeFlag() {
      this.changeFlag = !isEqual(this.snapshotPeriodData, this.snapshotPeriodDataOrigin);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/SnapshotPeriodSettings/index.vue